import React from 'react';

import RetryPaymentRivertyBase from '../RetryPaymentRivertyBase/RetryPaymentRivertyBase';

import { Locale } from '@types-internal';

export type RetryPaymentRivertyDirectDebitProps = {
  orderId: string;
  currency: string;
  siteId: number;
  customerId: string;
  sid?: string;
  amount: number;
  locale: Locale;
};

const RetryPaymentRivertyDirectDebit: React.FC<RetryPaymentRivertyDirectDebitProps> = (props) => {
  return (
    <RetryPaymentRivertyBase
      {...props}
      notificationId="rivertyDirectDebitPaymentNotification"
      messageKey="mzp.order.detail.payment.riverty.directdebit.reminder.message"
      noteKey="mzp.order.detail.payment.riverty.directdebit.reminder.note"
      transferKey="mzp.order.detail.payment.riverty.directdebit.reminder.transfer"
      alternativeKey="mzp.order.detail.payment.riverty.directdebit.reminder.alternative"
    />
  );
};

export default RetryPaymentRivertyDirectDebit;
